/**
 * exposed to outside as props
 */
export var ButtonTypeDLS;
(function (ButtonTypeDLS) {
    ButtonTypeDLS["PRIMARY"] = "PRIMARY";
    ButtonTypeDLS["SECONDARY"] = "SECONDARY";
    ButtonTypeDLS["TERTIARY"] = "TERTIARY";
})(ButtonTypeDLS || (ButtonTypeDLS = {}));
export var ButtonStateDLS;
(function (ButtonStateDLS) {
    ButtonStateDLS["DEFAULT"] = "DEFAULT";
    ButtonStateDLS["HOVER"] = "HOVER";
    ButtonStateDLS["DISABLED"] = "DISABLED";
})(ButtonStateDLS || (ButtonStateDLS = {}));
export var ButtonSizeDLS;
(function (ButtonSizeDLS) {
    ButtonSizeDLS["LARGE"] = "LARGE";
    ButtonSizeDLS["MEDIUM"] = "MEDIUM";
    ButtonSizeDLS["SMALL"] = "SMALL";
})(ButtonSizeDLS || (ButtonSizeDLS = {}));
export var ButtonIconAlignment;
(function (ButtonIconAlignment) {
    ButtonIconAlignment["LEFT"] = "LEFT";
    ButtonIconAlignment["RIGHT"] = "RIGHT";
})(ButtonIconAlignment || (ButtonIconAlignment = {}));
export var ButtonWidthTypeToken;
(function (ButtonWidthTypeToken) {
    ButtonWidthTypeToken["FULL"] = "FULL";
    ButtonWidthTypeToken["CONTENT"] = "CONTENT";
})(ButtonWidthTypeToken || (ButtonWidthTypeToken = {}));
//--todo add more Diff Combination for Radio
export var ButtonTypeTokens;
(function (ButtonTypeTokens) {
    ButtonTypeTokens["LargeFilled"] = "large-filled";
    ButtonTypeTokens["MediumFilled"] = "medium-filled";
    ButtonTypeTokens["SmallFilled"] = "small-filled";
    ButtonTypeTokens["IconFilled"] = "icon-filled";
    ButtonTypeTokens["LargeSoftFilled"] = "large-soft-filled";
    ButtonTypeTokens["MediumSoftFilled"] = "medium-soft-filled";
    ButtonTypeTokens["SmallSoftFilled"] = "small-soft-filled";
    ButtonTypeTokens["IconSoftFilled"] = "icon-soft-filled";
    ButtonTypeTokens["LargeOutline"] = "large-outline";
    ButtonTypeTokens["MediumOutline"] = "medium-outline";
    ButtonTypeTokens["SmallOutline"] = "small-outline";
    ButtonTypeTokens["IconOutline"] = "icon-outline";
    ButtonTypeTokens["LargeGhost"] = "large-ghost";
    ButtonTypeTokens["MediumGhost"] = "medium-ghost";
    ButtonTypeTokens["SmallGhost"] = "small-ghost";
    ButtonTypeTokens["IconGhost"] = "icon-ghost";
    ButtonTypeTokens["LargeElevated"] = "large-elevated";
    ButtonTypeTokens["MediumElevated"] = "medium-elevated";
    ButtonTypeTokens["SmallElevated"] = "small-elevated";
    ButtonTypeTokens["IconElevated"] = "icon-elevated";
    ButtonTypeTokens["GoogleLargeFilled"] = "google-large-filled";
    // FloatingAction = 'floating-action',
    // Interaction = 'interaction',
})(ButtonTypeTokens || (ButtonTypeTokens = {}));
